import React from 'react';
import { Badge } from './ui/badge';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Plus, X, Search, Check } from 'lucide-react';

const ServiceCatalogPicker = ({
  showCatalog, setShowCatalog, selectedServices, removeService,
  filteredCatalog, searchTerm, setSearchTerm,
  selectedCategory, setSelectedCategory, categories,
  formData, addService, job,
}) => {
  return (
    <div className="border border-brand/40 rounded-lg p-3 space-y-3 bg-brand/10">
      <div className="flex items-center justify-between">
        <span className="text-brand font-semibold text-xs">Yapilacak Hizmetler *</span>
        <Button type="button" size="sm" onClick={() => setShowCatalog(!showCatalog)}
          className="bg-brand hover:bg-brand text-white text-xs h-7 px-2" data-testid="add-service-btn">
          <Plus className="h-3 w-3 mr-1" />Hizmet Ekle
        </Button>
      </div>

      {selectedServices.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid="selected-services">
          {selectedServices.map(s => (
            <Badge key={s.id} className="bg-brand/50 text-brand/80 text-xs px-2 py-1 flex items-center gap-1">
              {s.name}
              <X className="h-3 w-3 cursor-pointer hover:text-red-400" onClick={() => removeService(s.id)} />
            </Badge>
          ))}
        </div>
      )}

      {job && formData.services.length > 0 && selectedServices.length === 0 && (
        <div className="text-gray-500 text-xs">
          <span className="text-gray-600">Mevcut (serbest metin): </span>
          {formData.services.join(', ')}
        </div>
      )}

      {showCatalog && (
        <div className="bg-gray-900 border border-gray-700 rounded-lg p-2 space-y-2" data-testid="service-catalog-dropdown">
          <div className="flex gap-2">
            <div className="relative flex-1">
              <Search className="absolute left-2 top-2 h-3.5 w-3.5 text-gray-500" />
              <Input value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Hizmet ara..." className="bg-gray-800 border-gray-700 text-white text-xs pl-7 h-7" />
            </div>
            <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}
              className="bg-gray-800 border border-gray-700 text-white rounded text-xs p-1">
              <option value="all">Tum Kategoriler</option>
              {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="max-h-40 overflow-y-auto space-y-0.5">
            {filteredCatalog.map(s => {
              const isSelected = formData.selectedServiceIds.includes(s.id);
              return (
                <div key={s.id} onClick={() => !isSelected && addService(s)}
                  className={`flex items-center justify-between p-1.5 rounded text-xs cursor-pointer transition ${isSelected ? 'bg-brand/30 text-brand' : 'hover:bg-gray-800 text-white'}`}>
                  <div>
                    <span className="font-medium">{s.name}</span>
                    <span className="text-gray-500 ml-1.5 text-[10px]">{s.categoryName}</span>
                  </div>
                  {isSelected ? <Check className="h-3 w-3 text-brand" /> : <Plus className="h-3 w-3 text-gray-500" />}
                </div>
              );
            })}
            {filteredCatalog.length === 0 && <p className="text-gray-500 text-xs text-center py-2">Hizmet bulunamadi</p>}
          </div>
        </div>
      )}

      <div>
        <label className="text-gray-500 text-xs">Hizmet Notu (opsiyonel)</label>
        <Input value={formData.serviceNotes} onChange={(e) => formData.onServiceNotesChange(e.target.value)}
          placeholder="Ek bilgi, ozel istek..." className="bg-gray-900 border-gray-700 text-white text-xs mt-1" />
      </div>
    </div>
  );
};

export default ServiceCatalogPicker;
